import { generateThumbnail } from '../utils/thumbnails';

import ysFixWebmDuration from './fix-webm-duration';
import Command from '../general/Command';
import Plugin from '../general/Plugin';

let mediaRecorder;
let recordedChunks = [];
let recordingTimer; let

  recordingTime = null;
// user must create or select a folder before recording

let uploadTask;
const blobs = [];

// Function to get the last video Take given a roll, a scene, a shot & a video folder Id
let getLastVideoTake = null;

let onUploadCallback = null;
let videoTakeFolderId = 0;

// We will  no longer download the clips to the user's computer
let shouldDownloadBackups = false;

const codecs = {
  vp8: {
    low: 2500,
    high: 5000,
    ext: 'webm',
  },
  h264: {
    low: 3750,
    high: 7500,
    ext: 'mp4',
  },
  vp9: {
    low: 2500,
    high: 5000,
    ext: 'webm',
  },
};
const currentCodec = 'h264';

const EVENTS = {
  hostRecording: 'host_recording',
};
class VideoRecorder extends Plugin {
  constructor(manager) {
    super();
    this.manager = manager;
    this.hostRecordingCommand = null;

    this.videoStream = null;
    this.audioStream = null;
    this.lowDataModeOn = false;
  }

  getCommands() {
    this.hostRecordingCommand = new Command(EVENTS.hostRecording, (data) => {
      document.querySelector('#recordingOn').classList.toggle('hidden', !data.args.recording);
    });
    return [this.hostRecordingCommand];
  }

  setVideoStream(stream) {
    this.videoStream = stream;
  }

  setAudioStream(stream) {
    this.audioStream = stream;
  }

  setLowDataMode(lowDataMode) {
    this.lowDataModeOn = lowDataMode;
  }

  async testVideoResolution(){
    const maxVideoHeight = 2000;
    const videoTooLargeErrorMessage = "The chosen video feed exceeds the supported resolution. Please modify your source's output setting to ensure they align with a maximum resolution of Full HD 1080p60";

    return new Promise((resolve, reject) => {
      console.log("Testing video resolution")
    // record a small snippet and then check the resolution
    // if the resolution is too low, then we can't record
    // and we should show an error message
    mediaRecorder = new MediaRecorder(this.videoStream);
    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        // create a hidden video element to preview the recording
        const video = document.createElement('video');
        video.src = URL.createObjectURL(event.data);
        video.setAttribute('style', 'display: none;');
        document.body.appendChild(video);
        // get video resolution
        video.onloadedmetadata = () => {
          const videoWidth = video.videoWidth;
          const videoHeight = video.videoHeight;
          console.log("Recorded video is", videoWidth, "x", videoHeight);
          // if the video height is 4k alert the user
          if (videoHeight >= maxVideoHeight) {
            reject(videoTooLargeErrorMessage);
          }
          resolve();
          video.remove();
        }
      }
    };
    mediaRecorder.start();
    // just record 1 second of video
    setTimeout(() => {
      mediaRecorder.stop();
    } , 1000);
    })
  }

  addTask(task) {
    return this.manager.addTask(task);
  }
}

const videoRecorderSingleton = new VideoRecorder();

// Function to set the auxiliar function
function setGetLastVideoTake(fn) {
  getLastVideoTake = fn;
}

function startVideoRecording() {
  if (videoTakeFolderId <= 0 || videoTakeFolderId === 'none') {
    return false;
  }
  recordedChunks = [];

  // options for mimetype: 'video/webm'
  const mimetype = `video/webm;codecs=${currentCodec},opus`;
  const videoBitsPerSecond = videoRecorderSingleton.lowDataModeOn ? codecs[currentCodec].low : codecs[currentCodec].high;
  const audioBitsPerSecond = 128;

  const options = {
    audioBitsPerSecond: audioBitsPerSecond * 1000,
    videoBitsPerSecond: videoBitsPerSecond * 1000,
    mimeType: mimetype,
  };

  let audioTrack;
  let videoTrack;
  let newStream;
  if (videoRecorderSingleton.audioStream && videoRecorderSingleton.audioStream.getAudioTracks) {
    videoRecorderSingleton.audioStream.getAudioTracks().forEach((track) => {
      audioTrack = track;
    });

    videoRecorderSingleton.videoStream.getVideoTracks().forEach((track) => {
      videoTrack = track;
    });
    newStream = new MediaStream([audioTrack, videoTrack]);
  } else {
    videoRecorderSingleton.videoStream.getVideoTracks().forEach((track) => {
      videoTrack = track;
    });
    newStream = new MediaStream([videoTrack]);
  }
  try {
    mediaRecorder = new MediaRecorder(newStream, options);
  } catch (e) {
    console.error('Exception while creating VideoMediaRecorder:', e);
    errorMsgElement.innerHTML = `Exception while creating VideoMediaRecorder: ${JSON.stringify(e)}`;
    return false;
  }

  mediaRecorder.ondataavailable = handleDataAvailable;
  mediaRecorder.start();
  startRecordingTimer();
  videoRecorderSingleton.hostRecordingCommand.sendAll({ recording: true });

  let recordingOn =  document.querySelector('#recordingOn')
  if (recordingOn){
    recordingOn.classList.toggle('hidden', false);
  } else {
    console.log("Didnt find recording on sign")
  }
  return true;
}

 function handleDataAvailable(event) {
  if (event.data.size > 0) {
    recordedChunks.push(event.data);
  } else {
    // ...
  }
}

function setVideoTakeFolderId(_videoTakeFolderId) {
  videoTakeFolderId = _videoTakeFolderId;
}

function stopVideoRecording(roll, scene, shot, rotation, aspectRatio, _onUploadCallback) {
  onUploadCallback = _onUploadCallback;

  let recordingOn =  document.querySelector('#recordingOn')
  if (recordingOn){
    recordingOn.classList.toggle('hidden', false);
  } else {
    console.log("Didnt find recording on sign")
  }
  const clipDuration = recordingTime;
  stopRecordingTimer();

  window.setTimeout(() => {
    mediaRecorder.stop();

    window.setTimeout(() => {
      const buggyBlob = new Blob(recordedChunks, { type: `video/webm;codecs=${currentCodec},opus` });
      ysFixWebmDuration(buggyBlob, clipDuration * 1000, (fixedBlob) => {
        blobs.push(fixedBlob);
        const blob = blobs[blobs.length - 1];
        const id = blobs.length - 1;
        const takeName = `${roll + (`0${scene}`).slice(-2) + (`0${shot}`).slice(-2)}_Take_${getLastVideoTake(roll, scene, shot, videoTakeFolderId) + 1}`;
        videoRecorderSingleton.hostRecordingCommand.sendAll({ recording: false });
        if (shouldDownloadBackups){
           download(blob, takeName);
        }
        uploadClip(blob, clipDuration, takeName, id, roll, scene, shot, rotation, aspectRatio);
      });
    }, 1000);
  }, 1000);
}

function displayRecordingTimer() {
  let h = parseInt(recordingTime / 3600, 10);
  let m = parseInt((recordingTime % 3600) / 60, 10);
  let s = parseInt(recordingTime % 60, 10);
  h = `${h}`.padStart(2, '0');
  m = `${m}`.padStart(2, '0');
  s = `${s}`.padStart(2, '0');
  document.querySelector('#recordingTime').innerHTML = `${h}:${m}:${s}`;
}

function startRecordingTimer() {
  recordingTimer = window.setInterval(() => {
    recordingTime += 1;
    displayRecordingTimer();
  }, 1000);
}

function stopRecordingTimer() {
  recordingTime = 0;
  if (recordingTimer) clearInterval(recordingTimer);
  displayRecordingTimer();
}

function download(blob, name = 'clip') {
  // var blob = new Blob(recordedChunks, {type: 'video/webm'});
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  a.href = url;
  a.download = `${name}.mirror`;
  a.click();
  window.URL.revokeObjectURL(url);
}

async function uploadClip(blob, clipDuration, name, id, roll, scene, shot, rotation, aspectRatio) {
  const thumbnail = await generateThumbnail(blob);

  const fd = new FormData();
  fd.append('file', blob, `${name}.${codecs[currentCodec].ext}`);
  fd.append('thumbnail', thumbnail, `${name}.png`);
  fd.append('duration_in_seconds', clipDuration);
  fd.append('name', name);
  fd.append('rotation', rotation);
  fd.append('aspect_ratio', aspectRatio);
  fd.append('upload_began_at', Date.now());
  fd.append('video_take_folder_id', videoTakeFolderId.toString());
  fd.append('authenticity_token', authenticity_token);
  fd.append('roll', roll);
  fd.append('scene', scene);
  fd.append('shot', shot);
  fd.append('room', room);

  const xhr = new XMLHttpRequest();
  xhr.responseType = 'json';
  xhr.open('POST', '/video_takes', true);
  xhr.onload = function (e) {
    const jsonResponse = xhr.response;
    // send jsonResponse.url to peers

    // TODO: what is this playbutton anyways??
    let playButton = document.querySelector(`#clip_${id} .playButton`)
    if (playButton){
      playButton.classList.remove('btn-disabled');
      playButton.removeAttribute('disabled');
    } else {
      console.log("Didnt find play button")
    }
    onUploadCallback(jsonResponse);
    uploadTask.done();
  };
  // Listen to the upload progress.
  // assuming you have a progress element on your dom
  // var progressBar = document.querySelector('progress#upload');

  xhr.upload.onprogress = function (e) {
    if (e.lengthComputable) {
      uploadTask.update(parseInt(e.loaded / e.total * 100, 10));
    }
    if ((e.loaded / e.total) === 1) {
      // finished upload
    }
  };
  xhr.upload.onerror = function (e) {
    $('#uploadingNow').addClass('hidden');
    handleError(`Error ${xhr.status} occurred uploading your file`);
    uploadTask.error();
  };

  xhr.send(fd);
  uploadTask = videoRecorderSingleton.addTask({ id: 'UPLOAD_VIDEO',
    determinate: true,
    message: 'Uploading video...'
  });
}

export {
  startVideoRecording, stopVideoRecording, setGetLastVideoTake, setVideoTakeFolderId,
  videoRecorderSingleton,
};
